"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for management Station Board API calls.
 */
var StationBoardMixin = /** @class */ (function () {
    function StationBoardMixin() {
    }
    /**
     * Submit a request to start a Station Board trial via the API
     * @param agencyId
     * @param callback
     */
    StationBoardMixin.prototype.sendStationBoardTrialRequest = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AuthAgency.parse));
        };
        this.http.post("/agencies/" + agencyId + "/station-boards/trial", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an agency's Station Boards w/ pagination
     * @param agencyId
     * @param limit
     * @param page
     * @param sortConfig
     * @param search
     * @param callback
     */
    StationBoardMixin.prototype.getStationBoards = function (agencyId, limit, page, sortConfig, search, callback) {
        var _this = this;
        var urlParams = {
            order: sortConfig.direction,
        };
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'boards', models_1.MinimalStationBoard.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/station-boards", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get a specific Station Board by ID
     * @param agencyId
     * @param boardId
     * @param callback
     */
    StationBoardMixin.prototype.getStationBoard = function (agencyId, boardId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullStationBoard.parse));
        };
        this.http.get("/agencies/" + agencyId + "/station-boards/" + boardId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a Station Board for an agency
     * @param agencyId
     * @param name
     * @param unitIds
     * @param stationId
     * @param messagingGroupId
     * @param activeLayers
     * @param inactiveLayers
     * @param baseLayer
     * @param activeZoom
     * @param inactiveZoom
     * @param activeTime
     * @param messageDuration
     * @param userInactiveTime
     * @param userExpireTime
     * @param apparatusInactiveTime
     * @param apparatusExpireTime
     * @param dayStartMin
     * @param dayEndMin
     * @param dayTurnoutTime
     * @param nightTurnoutTime
     * @param redTime
     * @param blinkTime
     * @param turnoutStart
     * @param callback
     */
    StationBoardMixin.prototype.createStationBoard = function (agencyId, name, unitIds, stationId, messagingGroupId, activeLayers, inactiveLayers, baseLayer, activeZoom, inactiveZoom, activeTime, messageDuration, userInactiveTime, userExpireTime, apparatusInactiveTime, apparatusExpireTime, dayStartMin, dayEndMin, dayTurnoutTime, nightTurnoutTime, redTime, blinkTime, turnoutStart, callback) {
        var _this = this;
        var body = {
            name: name,
            unitIds: unitIds,
            stationId: stationId,
            messagingGroupId: messagingGroupId,
            activeLayers: activeLayers.map(function (l) { return models_1.StationBoardActiveLayer[l]; }),
            inactiveLayers: inactiveLayers.map(function (l) { return models_1.StationBoardInactiveLayer[l]; }),
            baseLayer: models_1.StationBoardBaseLayer[baseLayer],
            activeZoom: models_1.StationBoardActiveZoom[activeZoom],
            inactiveZoom: inactiveZoom,
            activeTime: activeTime,
            messageDuration: messageDuration,
            userInactiveTime: userInactiveTime,
            userExpireTime: userExpireTime,
            apparatusInactiveTime: apparatusInactiveTime,
            apparatusExpireTime: apparatusExpireTime,
            dayStart: dayStartMin,
            dayEnd: dayEndMin,
            dayTurnoutTime: dayTurnoutTime,
            nightTurnoutTime: nightTurnoutTime,
            redTime: redTime,
            blinkTime: blinkTime,
            turnoutStart: models_1.StationBoardTurnoutStartCondition[turnoutStart],
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.BasicStationBoard.parse));
        };
        this.http.post("/agencies/" + agencyId + "/station-boards", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a Station Board by ID
     * @param agencyId
     * @param boardId
     * @param name
     * @param unitIds
     * @param stationId
     * @param messagingGroupId
     * @param activeLayers
     * @param inactiveLayers
     * @param baseLayer
     * @param activeZoom
     * @param inactiveZoom
     * @param activeTime
     * @param messageDuration
     * @param userInactiveTime
     * @param userExpireTime
     * @param apparatusInactiveTime
     * @param apparatusExpireTime
     * @param dayStartMin
     * @param dayEndMin
     * @param dayTurnoutTime
     * @param redTime
     * @param blinkTime
     * @param turnoutStart
     * @param callback
     */
    StationBoardMixin.prototype.editStationBoard = function (agencyId, boardId, name, unitIds, stationId, messagingGroupId, activeLayers, inactiveLayers, baseLayer, activeZoom, inactiveZoom, activeTime, messageDuration, userInactiveTime, userExpireTime, apparatusInactiveTime, apparatusExpireTime, dayStartMin, dayEndMin, dayTurnoutTime, nightTurnoutTime, redTime, blinkTime, turnoutStart, callback) {
        var _this = this;
        var body = {
            name: name,
            unitIds: unitIds,
            stationId: stationId,
            messagingGroupId: messagingGroupId,
            activeLayers: activeLayers != null ? activeLayers.map(function (l) { return models_1.StationBoardActiveLayer[l]; }) : null,
            inactiveLayers: inactiveLayers != null ? inactiveLayers.map(function (l) { return models_1.StationBoardInactiveLayer[l]; }) : null,
            baseLayer: baseLayer != null ? models_1.StationBoardBaseLayer[baseLayer] : null,
            activeZoom: activeZoom != null ? models_1.StationBoardActiveZoom[activeZoom] : null,
            inactiveZoom: inactiveZoom,
            activeTime: activeTime,
            messageDuration: messageDuration,
            userInactiveTime: userInactiveTime,
            userExpireTime: userExpireTime,
            apparatusInactiveTime: apparatusInactiveTime,
            apparatusExpireTime: apparatusExpireTime,
            dayStart: dayStartMin,
            dayEnd: dayEndMin,
            dayTurnoutTime: dayTurnoutTime,
            nightTurnoutTime: nightTurnoutTime,
            redTime: redTime,
            blinkTime: blinkTime,
            turnoutStart: turnoutStart,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.BasicStationBoard.parse));
        };
        this.http.put("/agencies/" + agencyId + "/station-boards/" + boardId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a Station Board by ID
     * @param agencyId
     * @param boardId
     * @param callback
     */
    StationBoardMixin.prototype.deleteStationBoard = function (agencyId, boardId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/station-boards/" + boardId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a Station Board session by ID
     * @param agencyId
     * @param boardId
     * @param sessionId
     * @param callback
     */
    StationBoardMixin.prototype.deleteStationBoardSession = function (agencyId, boardId, sessionId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/station-boards/" + boardId + "/sessions/" + sessionId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return StationBoardMixin;
}());
exports.default = StationBoardMixin;
//# sourceMappingURL=StationBoardMixin.js.map